module.exports = __webpack_public_path__ + "static/media/DR4.464cc51e.jpeg";